export enum RealEstateTenureTypeEnum {
  PROPRIETA = "proprietà",
  LOCAZIONE = "locazione",
  NUDA_PROPRIETA = "nuda_proprietà",
  USUFRUTTO = "usufrutto",
  COMODATO_USO_GRATUITO = "comodato_uso_gratuito",
  ALTRO = "altro",
}

export const REAL_ESTATE_TENURE_TYPE_LABELS: Record<RealEstateTenureTypeEnum, string> = {
  [RealEstateTenureTypeEnum.PROPRIETA]: "Di proprietà",
  [RealEstateTenureTypeEnum.LOCAZIONE]: "In affitto",
  [RealEstateTenureTypeEnum.NUDA_PROPRIETA]: "Nuda proprietà",
  [RealEstateTenureTypeEnum.USUFRUTTO]: "In usufrutto",
  [RealEstateTenureTypeEnum.COMODATO_USO_GRATUITO]: "In comodato d'uso",
  [RealEstateTenureTypeEnum.ALTRO]: "Altro tipo",
};
